import { useState } from "react";

const COOKIE_NAME = "cookie_consent";

function hasConsented(): boolean {
  return document.cookie
    .split(";")
    .some((c) => c.trim().startsWith(`${COOKIE_NAME}=`));
}

function accept(setVisible: (v: boolean) => void) {
  const expires = new Date();
  expires.setFullYear(expires.getFullYear() + 1);
  document.cookie = `${COOKIE_NAME}=true; expires=${expires.toUTCString()}; path=/`;
  setVisible(false);
}

export default function CookieBanner() {
  const [visible, setVisible] = useState(() => !hasConsented());

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50">
      <div className="mx-auto rounded-t cookie-banner border border-[#EDE8DF] overflow-hidden">
        <div className="max-w-6xl mx-auto px-6 py-5 flex flex-col lg:flex-row items-start lg:items-center gap-4 lg:gap-8">
          <div className="flex items-start gap-3 flex-1 min-w-0">
            <div>
              <p className="text-md font-semibold text-[#1a1a2e] mb-0.5">
                We use cookies on this website
              </p>
              <p className="text-xs text-[#6a6a7a] leading-relaxed">
                We use essential and optional cookies in line with UK GDPR and
                PECR. Optional cookies help us improve performance and deliver
                relevant content. You can manage your preferences or accept all
                cookies below.{" "}
                <a
                  href="#"
                  rel="nofollow"
                  className="text-[#1a1a2e] underline underline-offset-2 hover:text-[#c4875a] transition-colors cursor-pointer"
                >
                  Privacy Policy
                </a>
              </p>
            </div>
          </div>
          <div className="flex flex-wrap items-center gap-2 flex-shrink-0">
            {/* <button
              onClick={() => setVisible(false)}
              className="text-xs font-semibold text-[#6a6a7a] border border-[#D0C9BE] px-4 py-2 rounded hover:border-[#1a1a2e] hover:text-[#1a1a2e] transition-colors cursor-pointer whitespace-nowrap"
            >
              Reject Non-Essential
            </button>
            <button
              onClick={() => setVisible(false)}
              className="text-xs font-semibold text-[#1a1a2e] border border-[#1a1a2e] px-4 py-2 rounded hover:bg-[#EFEBE5] transition-colors cursor-pointer whitespace-nowrap"
            >
              Manage Preferences
            </button> */}
            <button
              onClick={() => accept(setVisible)}
              className="text-xs font-semibold bg-[#222222] text-white px-5 py-2 rounded-full hover:bg-[#000000] transition-colors cursor-pointer whitespace-nowrap"
            >
              I agree
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
